import {
  DashboardOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  SettingOutlined,
  ControlOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  TeamOutlined,
  EditOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserRoles } from 'src/redux/features/users/usersSlice';
import { isAuthorised } from 'src/utils/helpers';
import en from 'src/messages/en.json';

export const SideNavItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRoles = useSelector(getUserRoles);

  type MenuItem = {
    key: string;
    icon?: React.ReactNode;
    label: string;
    role?: (string | string[])[];
    children?: MenuItem[];
  };

  const menuItems: MenuItem[] = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: en.Common.Label.dashboard,
    },
    {
      key: '/timesheet',
      icon: <CalendarOutlined />,
      label: en.Timesheet.Label.timeSheet,
    },
    {
      key: 'approvals',
      icon: <CheckSquareOutlined />,
      label: en.Common.Label.approvals,
      children: [
        {
          key: '/team-timesheet',
          label: en.Timesheet.Label.teamTimeSheet,
          // icon: <TeamOutlined />,
          role: ['CapexAdmin', 'CapexAdManager'],
        },
        {
          key: '/bulk-approvals',
          label: en.Timesheet.Label.bulkApprovals,
          // icon: <FileDoneOutlined />,
          role: ['CapexAdManager'],
        },
      ],
    },
    {
      key: 'managePOs',
      icon: <ControlOutlined />,
      label: en.Common.Label.managePOs,
      children: [
        {
          key: '/manage-po',
          label: en.POs.Label.managePOs,
          // icon: <FileSearchOutlined />,
          role: ['CapexITLeader'],
        },
        {
          key: '/po-receiving',
          label: en.POs.Label.receiveRequests,
          // icon: <FileSearchOutlined />,
          role: ['CapexITLeader'],
        },
      ],
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: en.Common.Label.settings,
      children: [
        {
          key: '/manage-activities',
          label: en.Activities.Label.editActivities,
          // icon: <EditOutlined />,
          role: ['CapexAdmin', 'CapexProjectLeader', 'CapexCategoryManager'],
        },
        {
          key: '/project-access',
          label: en.Access.Label.editAccess,
          // icon: <KeyOutlined />,
          role: ['CapexProjectLeader'],
        },
        {
          key: '/edit-products',
          label: en.Projects.Label.editProductInitiatives,
          role: ['CapexAdmin'],
        },
        {
          key: '/edit-email-notifications',
          label: en.Timesheet.Label.editEmailNotifications,
          role: ['CapexAdManager'],
        },
      ],
    },
  ];

  const filteredMenuItems = menuItems
    .map((item) => {
      if (item.children) {
        const filteredChildren = item.children.filter((child) =>
          child.role ? isAuthorised(userRoles.data, child.role) : true,
        );

        return filteredChildren.length > 0
          ? { ...item, children: filteredChildren }
          : null;
      } else {
        return item.role
          ? isAuthorised(userRoles?.data, item.role)
            ? item
            : null
          : item;
      }
    })
    .filter(Boolean);

  const selectedKey =
    location.pathname === '/' ? '/timesheet' : location.pathname;

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      className="custom-sider-menu"
      style={{
        height: '100%',
        borderRight: 0,
        textAlign: 'left',
        overflow: 'auto',
      }}
      onClick={({ key }) => navigate(key)}
      items={filteredMenuItems}
    />
  );
};
